import {NgModule} from '@angular/core';

import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './layout/layout.component';
import {P404Component} from './404.component';
import {mainRoutes} from './main-routes';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: LayoutComponent,
    // canActivate: [AuthorizationService],
    children: [
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule',
      },
      ...mainRoutes
    ]
  },
  {path: '**', component: P404Component}
];

@NgModule({
  // imports: [RouterModule.forRoot(routes, {enableTracing: true})],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
